module.exports = __webpack_public_path__ + "img/open-folder.37679107.svg";